"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * warning
 *
 * Prints a warning in the console if it exists.
 * @param message The warning message.
 */
function warning(message) {
    /* eslint-disable no-console */
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
        console.error(message);
    }
    /* eslint-enable no-console */
    try {
        // This error was thrown as a convenience so that if you enable
        // 'break on all exceptions' in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    }
    catch (e) { } // eslint-disable-line no-empty
}
exports.default = warning;
//# sourceMappingURL=warning.js.map